import React from 'react';
import { motion } from 'framer-motion';
import { hero } from '../data/homepage';
import { HeroAtna } from './HeroAtna';

/** Organic blob the Town uses to mask its photography. */
const BLOB = '58% 42% 46% 54% / 44% 56% 44% 56%';
export function Hero() {
  return <section aria-labelledby="hero-title" className="relative w-full overflow-hidden bg-ville-blue" data-id="element-1316" data-mp="2i9v3eq47pxj3">
      <div className="mx-auto grid max-w-[1400px] items-stretch gap-10 px-5 pb-4 pt-10 lg:grid-cols-[minmax(0,48%)_minmax(0,1fr)] lg:gap-14 lg:px-10 lg:pt-14" data-id="element-1317" data-mp="2dbbh2olpijq7">
        <motion.div className="min-w-0" initial={{
        opacity: 0,
        y: 18
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.4,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-1318" data-mp="1kll96xao4e2j">
          <p className="font-display text-xl font-bold text-ville-spring" data-id="element-1319" data-mp="1ukkce0cnzhi5">{hero.eyebrow}</p>
          <h1 id="hero-title" className="mt-2 font-display text-[2.75rem] font-extrabold leading-[0.98] tracking-tight text-ville-lime sm:text-6xl lg:text-[4.25rem]" data-id="element-1320" data-mp="39xetqlxx18x4">
            {hero.title}
          </h1>
          {hero.body.map((paragraph, index) => <p key={paragraph} className={`max-w-xl text-[15px] leading-relaxed text-white/90 lg:text-base ${index === 0 ? 'mt-7' : 'mt-4'}`} data-id="element-1321" data-mp="3gg07qky56uyc" data-mpi={index}>
              {paragraph}
            </p>)}
          <a href="#accueil" className="mt-7 inline-flex items-center rounded-full border-2 border-ville-lime px-7 py-2.5 font-display text-[17px] font-bold text-ville-lime transition-colors duration-150 ease-ville hover:bg-ville-lime hover:text-ville-navy focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-spring focus-visible:ring-offset-2 focus-visible:ring-offset-ville-blue" data-id="element-1322" data-mp="3ph7x2dioklga">
            {hero.cta}
          </a>
        </motion.div>

        <div className="mx-auto flex w-full max-w-[560px] flex-col pb-6 lg:pb-0" data-id="element-1323" data-mp="36jwuaixub9w3">
          <div className="relative mx-auto w-4/5 max-w-[448px]" data-id="element-1324" data-mp="291wqmuz099y8">
            <span aria-hidden="true" className="absolute -inset-4 border-2 border-ville-spring sm:-inset-6" style={{
            borderRadius: BLOB
          }} data-id="element-1325" data-mp="2e1rmlcxn0pq5" />
            <img src={hero.image} alt="" className="relative block aspect-[4/3] w-full object-cover" style={{
            borderRadius: BLOB
          }} data-id="element-1326" data-mp="3hb3zfbe0moir" />
          </div>

          <div className="mt-10 lg:mt-auto lg:pt-12" data-id="element-1327" data-mp="3q3yytogsxq0m">
            <HeroAtna data-id="element-1328" data-mp="3m3nignvh2buy" />
          </div>
        </div>
      </div>

      <div aria-hidden="true" className="-mb-px w-full" data-id="element-1329" data-mp="3m4gotnqiqzck">
        <svg viewBox="0 0 1440 140" preserveAspectRatio="none" className="block h-[64px] w-full sm:h-[110px]" data-id="element-1330" data-mp="2ydaz8gus0sp2">
          <path d="M0,84 C210,132 430,32 720,56 C1010,80 1230,128 1440,82 L1440,140 L0,140 Z" fill="#8d7a1f" opacity="0.5" data-id="element-1331" data-mp="2tg1br6qy6r3v" />
          <path d="M0,104 C230,148 420,50 720,76 C1020,102 1240,144 1440,100 L1440,140 L0,140 Z" fill="#f5b41c" data-id="element-1332" data-mp="37g2dspiy84kx" />
        </svg>
      </div>
    </section>;
}